// extracted by mini-css-extract-plugin
module.exports = {"SideBar":"SideBar_SideBar__1OEZ-","Show":"SideBar_Show__2SrGV","Hide":"SideBar_Hide__2kw0G","NavigationItems":"SideBar_NavigationItems__XKiJ1","Close":"SideBar_Close__2rgeM"};